// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3Xdtc","savePackageButton":"ClientWallet_savePackageButton__1gMMb"};